module.exports = __webpack_public_path__ + "media/images/icons/mail-542ec34db0899cd547d6ad3c50c2c08d.svg";